import {PRATICIENS_ROUTES as praticienneRoutes} from "~/api/routes";

export const state = () => ({
  praticiennes: [],
  details: null,
  close:false,
  isRequesting:false
});
export const getters = {};
export const mutations = {
  PRATICIENNES_LOAD(state) {
    //state.isLoading = true;
    state.hasError = false;
    state.praticiennes = [];
    //state.page = page;
  },
  PRATICIENNE_SUCCES(state, praticiennes) {
    state.praticiennes = praticiennes;
    //state.pagination = params.payload.pagination;
    //state.filters = params.filters || state.filters;
  },
  CLOSE_MODAL(state,close){
    state.close = close;
  },
  IS_REQUESTING(state,isRequesting){
    state.isRequesting = isRequesting
  },
  PRATICIENNES_ERROR(state) {
    state.praticiennes = [];
    state.hasError = true;
  },
  PRATICIENNES_LOADED(state) {
    //state.isLoading = false;
  },
  PRATICIENNE_PROCESSING_START(state) {
    //state.isLoading = false;
  },
  PRATICIENNE_PROCESSING_END(state) {
    //state.isLoading = false;
  },
  PRATICIENNE_ERROR(state) {
    //state.isLoading = false;
  },
  UPDATE_A_PRATICIENNE(state, praticienne) {
    let index = state.praticiennes.findIndex((elem) => elem.praticienne_id === praticienne.praticienne_id);
    state.praticiennes = state.praticiennes.filter(element => element.praticienne_id !== praticienne.praticienne_id);
    state.praticiennes.splice(index, 0, praticienne);
  },
  PRESTATAIRE_SUCCES(state, details) {
    state.details = details
    //state.isLoading = false;
  },
  ADD_PRATICIENNE_TO_LIST(state, praticienne) {
    state.praticiennes.unshift(praticienne);
  },
  REMOVE_PRATICIENNE_TO_LIST(state, praticienne) {
    state.praticiennes = state.praticiennes.filter(element => element.praticienne_id !== praticienne.praticienne_id);
  },
  REMOVE_PRATICIENNE_IMAGE(state, praticienne_id) {
    let index = state.praticiennes.findIndex((elem) => elem.praticienne_id === praticienne_id);
    state.praticiennes[index].image=null
  },
};
export const actions = {
  async getPraticiennes({commit}) {
    commit('PRATICIENNES_LOAD');
    commit('IS_REQUESTING',true);
    this.$api.request(praticienneRoutes.list)
      .then(response => {
        commit('PRATICIENNE_SUCCES', response.payload);
      })
      .catch(error => {
        commit('PRATICIENNES_ERROR');
      })
      .finally(() => {
        commit('PRATICIENNES_LOADED');
        commit('IS_REQUESTING',false);
      });
  },
  async createPraticienne({commit}, params) {
    commit('PRATICIENNE_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(praticienneRoutes.create, {}, params.formData)
      .then(response => {
        //commit('PRATICIENNE_SUCCES', response);
        commit('CLOSE_MODAL',true);
        commit('ADD_PRATICIENNE_TO_LIST', response.payload);
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('PRATICIENNE_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('PRATICIENNE_PROCESSING_END')
      });
  },
  async updatePraticienne({commit}, params) {
    commit('PRATICIENNE_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(praticienneRoutes.update, {id: params.id}, params.formData)
      .then(response => {
        //commit('PRATICIENNE_SUCCES', response);
        commit('CLOSE_MODAL',true);
        commit('UPDATE_A_PRATICIENNE', response.payload);
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('PRATICIENNE_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('PRATICIENNE_PROCESSING_END')
      });
  },
  async deletePraticienne({commit}, params) {
    commit('PRATICIENNE_PROCESSING_START');
    await this.$api.request(praticienneRoutes.delete, {id: params.praticienne_id})
      .then(response => {
        //commit('PRATICIENNE_SUCCES', response);
        commit('REMOVE_PRATICIENNE_TO_LIST', params);
      })
      .catch(error => {
        commit('PRATICIENNE_ERROR');
      })
      .finally(() => commit('PRATICIENNE_PROCESSING_END'));
  },
  async getPraticienne({commit}, params) {
    commit('PRATICIENNE_PROCESSING_START');
    await this.$api.request(praticienneRoutes.get, {id: params.praticienne_id})
      .then(response => {
        commit('PRESTATAIRE_SUCCES', response.payload);
      })
      .catch(error => {
        commit('PRATICIENNE_ERROR');
      })
      .finally(() => commit('PRATICIENNE_PROCESSING_END'));
  },
  async removeImage({ commit }, params){
    commit('REMOVE_PRATICIENNE_IMAGE', params.id);
  }
};
